import { Component, ViewChild } from '@angular/core';
import { BzgToastService, BzgModalService, BzgSlideDown } from 'bz-genome-angular';
import { TranslateService } from '@ngx-translate/core';
import { ConnectConnectorsService } from '../core/connect-connectors.service';
import { ConnectorsInterfaceComponent } from './connectors-interface/connectors-interface.component';
import { ConnectorsSapComponent } from './connectors-sap/connectors-sap.component';
import { PendingChangesConnectAlertComponent } from '../modal-actions/connect-pendingchanges.component';
import { IConnector, IConnectorType, ISapTestResponse } from '../core/IConnector';

@Component({
  selector: 'connect-connectors',
  templateUrl: 'connect-connectors.component.html',
  styleUrls: ['connect-connectors.component.scss'],
  animations: [BzgSlideDown]
})
export class ConnectConnectorsComponent {

  public connectorsType: Array<IConnectorType>;
  public selectedConnector: IConnector;
  public selectedConnectorType: IConnectorType;
  public selectedConnectorDisplayName: string;
  public selectedConnectorName: string;
  public selectedConnectorDescription: string;
  public isBusy: boolean;
  public metadata: any;
  public testResponse: ISapTestResponse;
  private _prevSelectedConnector: IConnector;

  @ViewChild('connectorsInterface', { static: false}) connectorsInterface: ConnectorsInterfaceComponent;
  @ViewChild('connectorsSap', { static: false}) connectorsSap: ConnectorsSapComponent;

  constructor(private _connectConnectorsService: ConnectConnectorsService, private _toastService: BzgToastService,
    private _translateService: TranslateService, private _modalService: BzgModalService) { }

  async ngOnInit() {
    this.connectorsType = await this._connectConnectorsService.getConnectors();
    this.metadata = await this._connectConnectorsService.getConnectorMetadata();
  }

  async selectConnector(connectorType: IConnectorType, connectorDefinition: IConnectorType) {
    this._updateCurrentConnector();
    this.isBusy = true;
    if (this._prevSelectedConnector && this.selectedConnector) {
      if (this._arePendingChanges(this._prevSelectedConnector, this.selectedConnector)) {
        this._showPendingChangesDialog(async () => {
          await this.applyChanges();
          this._updateSelectedData(connectorType, connectorDefinition);
          this.setSelectedConnectorPrev(connectorType, connectorDefinition);
        }, () => {
          this._updateSelectedData(connectorType, connectorDefinition);
          this.setSelectedConnectorPrev(connectorType, connectorDefinition)
        });
      } else {
        this._updateSelectedData(connectorType, connectorDefinition);
        this.setSelectedConnectorPrev(connectorType, connectorDefinition);
      }
    } else {
      this._updateSelectedData(connectorType, connectorDefinition);
      this.setSelectedConnectorPrev(connectorType, connectorDefinition);

    }

    this.isBusy = false;

  }
  private _updateSelectedData(connectorType: IConnectorType, connectorDefinition: IConnectorType) {
    this.selectedConnectorDisplayName = connectorDefinition.displayName;
    this.selectedConnectorName = connectorDefinition.name;
    this.selectedConnectorType = connectorType;
    this.selectedConnectorDescription = connectorDefinition.description;

  }
  private _arePendingChanges(prevConnector: IConnector, currentConnector: IConnector) {
    // if (currentConnector.type === "ConnectorConfiguration") {
    // let pendingChanges = false;
    // _.forEach((<ISAPConnector>prevConnector).properties, (property: {[key: string]: any}, index: number) => {
    //   if (!pendingChanges && !_.isEmpty(property)) {
    //     pendingChanges = !_.isEqual((<IInterfaceConnector>currentConnector).content.properties[index],
    //     (<IInterfaceConnector>prevConnector).content.properties[index]);
    //   }
    // });
    // return !_.isEqual(this._prevSelectedConnector, this.selectedConnector);
    // } else {
    return !_.isEqual(this._prevSelectedConnector, this.selectedConnector);
    // }
  }

  private _showPendingChangesDialog(saveAction: Function, cancelAction: Function) {
    const modal = this._modalService.open(
      PendingChangesConnectAlertComponent,
      { closeOnBackdropClick: false, closeOnRouterNavigation: true }
    );
    modal.afterClosed().subscribe((result: string) => {
      if (result === 'save') {
        saveAction();
      } else {
        cancelAction();
      }
    });
  };

  private async setSelectedConnectorPrev(connectorType: IConnectorType, connectorDefinition: IConnectorType) {
    this.selectedConnector = await this._connectConnectorsService.getConnector(connectorType.type, connectorDefinition.id);
    this._prevSelectedConnector = _.cloneDeep(this.selectedConnector);
  }

  public saveConnector() {
    if (this._updateCurrentConnector(true)) {
      this._prevSelectedConnector = _.cloneDeep(this.selectedConnector);
      this.applyChanges();
    }
  }

  public TestConnection() {
    this.TestSAPConnection();
  }

  public async TestSAPConnection() {
    this.isBusy = true;
    if (this.isConnectorDataValid()) {
      let connectorToSave = _.cloneDeep(this.selectedConnector);
      if (this.selectedConnectorType.type === "InterfaceConnector" && this.connectorsInterface) {
        connectorToSave = await this.connectorsInterface.getEncryptedPasswords();
      } else if (this.connectorsSap) {
        connectorToSave = await this.connectorsSap.getEncryptedPasswords();
      }
      let response = await this._connectConnectorsService.testConnector(connectorToSave).then(res => {
        if (res.Success) {
          this._translateService.get('CONNECTORS.TEST_CONNECTION_SUCCESS').subscribe((message: string) => {
            this._toastService.open(
              message,
              {
                type: "success",
                duration: 5000,
                verticalPosition: "top",
                horizontalPosition: "right"
              });
          });
        } else {
          var errorMessage = res.ErrorMessage
          if (errorMessage == "SAP_NOT_IMPLEMENTED_EXCEPTION") {
            this._translateService.get('CONNECTORS.SAP_NOT_IMPLEMENTED_EXCEPTION').subscribe((message: string) => {
              this._toastService.open(
                message,
                {
                  type: "error",
                  duration: 0,
                  verticalPosition: "top",
                  horizontalPosition: "right"
                });
            });
          } else {
            this._toastService.open(
              res.ErrorMessage,
              {
                type: "error",
                duration: 0,
                verticalPosition: "top",
                horizontalPosition: "right"
              });
          }

        }
      });


    } else {
      this._translateService.get('GLOBAL.INVALID_FORM').subscribe((message: string) => {
        this._toastService.open(
          message,
          {
            type: "error",
            duration: 0,
            verticalPosition: "top",
            horizontalPosition: "right"
          });
      });
    }
    this.isBusy = false;
  }

  public cancelChanges() {
    this.selectedConnector = _.cloneDeep(this._prevSelectedConnector);
  }

  public async applyChanges() {
    this.isBusy = true;
    if (this.isConnectorDataValid()) {
      let connectorToSave = _.cloneDeep(this.selectedConnector);
      if (this.selectedConnectorType.type === 'InterfaceConnector' && this.connectorsInterface) {
        connectorToSave = await this.connectorsInterface.getEncryptedPasswords();
      } else if (this.connectorsSap) {
        connectorToSave = await this.connectorsSap.getEncryptedPasswords();
      }
      await this._connectConnectorsService.saveConnector(connectorToSave);
      this._translateService.get('GLOBAL.THE_OPERATION_WAS_SAVED_SUCCESSFULLY').subscribe((message: string) => {
        this._toastService.open(
          message,
          {
            type: 'success',
            duration: 0,
            verticalPosition: 'top',
            horizontalPosition: 'right'
          });
      });
    } else {
      this._translateService.get('GLOBAL.INVALID_FORM').subscribe((message: string) => {
        this._toastService.open(
          message,
          {
            type: 'error',
            duration: 0,
            verticalPosition: 'top',
            horizontalPosition: 'right'
          });
      });
    }
    this.isBusy = false;
  }

  public isConnectorDataValid() {
    let isValid = true;
    if (this.selectedConnectorType) {
      if (this.selectedConnectorType.type === 'InterfaceConnector' && this.connectorsInterface) {
        isValid = this.connectorsInterface.isValid();
      }
    }
    return isValid;
  }

  private _updateCurrentConnector(save?:boolean) {
    if (this.selectedConnectorType) {
      if (this.selectedConnectorType.type === 'InterfaceConnector' && this.connectorsInterface) {
        return this.connectorsInterface.updateSelectedConnectorProperties(save);
      } else if (this.connectorsSap && save) {
          return true;
      }
    }
  }
}
